"use strict";

angular.module("licensure.services").factory("EXExaminersList", [
    "$http",
    "$q",
    function ($http, $q) {
        return {
            getFilter: function (filter) {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/ExamModule/ExamExaminersFilter", {
                        params: {
                            currentPage: filter.currentPage,
                            numPerPage: filter.numPerPage,
                            reverse: filter.reverse,
                            sortBy: filter.sortBy,
                            search: filter.search,
                            alphaFilter: filter.alphaFilter,
                            internal: (filter.filters && filter.filters.length > 0 && filter.filters[0].value != undefined && filter.filters[0].value != null) ? filter.filters[0].value : null,
                            licenseCategoryLevelId: (filter.filters && filter.filters.length > 1 && filter.filters[1].value != undefined && filter.filters[1].value != null) ? filter.filters[1].value : null,
                        }
                    })
                    .then(function (response) {
                        var records = response.data && response.data.records ? response.data.records : [];

                        records.forEach(function (record) {
                            if (record && record.name === undefined && record.fullName !== undefined) {
                                record.name = record.fullName;
                            }
                        });

                        d.resolve(records);
                    })
                    .catch(function (response) {
                        d.resolve(null);
                    });
                return d.promise;
            },

            getCount: function (filter) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/ExamModule/ExamExaminersFilter/getCount', {
                        params: {
                            search: filter.search,
                            alphaFilter: filter.alphaFilter,
                            internal: (filter.filters && filter.filters.length > 0 && filter.filters[0].value != undefined && filter.filters[0].value != null) ? filter.filters[0].value : null,
                            licenseCategoryLevelId: (filter.filters && filter.filters.length > 1 && filter.filters[1].value != undefined && filter.filters[1].value != null) ? filter.filters[1].value : null,
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        d.resolve(null);
                    });

                return d.promise;
            },
        };
    }
]);
